namespace SPA
{
	export namespace gui
	{
		export namespace address
		{
			export type AddressType = "Fax"|"Email"|"Phone"|"PostalAddress"|"POBox";

			export class NewAddressItem extends ui.base.BaseHTMLElement
			{

				private m_Orga:				Organization.gui.OrgaTree;
				private m_Type:				AddressType;
				private m_Recipient:	Wollmilch.RecipientObject;

				public constructor(
					orga: Organization.gui.OrgaTree,
					type: AddressType,
					rec: Wollmilch.RecipientObject
				)
				{
					super( 'new-address' );

					this.m_Orga				= orga;
					this.m_Type				= type;
					this.m_Recipient	= rec;

					this.css(
						{
							'padding-bottom': '3px',
							'border-bottom': '1px dashed RGBA( 0, 0, 0, 0.15 )'
						}
					);
				}

				public rebuild( root: JQuery | ui.base.BaseHTMLElement ): NewAddressItem
				{
					this.empty();
					this.remove();

					this.appendTo( root );

					const form = new ui.Form.Form(
						{
							action: 'address/new/' + this.m_Type,
							method: 'POST',
							notSwitchable: true,
							submit: ( _method: ui.Form.FormMethod, _url: string, _parameter: ui.Form.IFormParameter ) =>
							{
								new Wollmilch.AJAX(
									{
										url: _url,
										method: _method,
										data: _parameter,
										on:
										{
											success: ( text: string ) =>
											{
												const obj = Wollmilch.jsonize( text );

												if ( obj === null )
												{
													app.addNotify(
														{
															body: [ 'Es ist ein Fehler beim Erstellen der Adresse aufgetreten.' ],
															title: [ 'Fehler' ],
															context: "danger",
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												new Wollmilch.AJAX(
													{
														url: 'organization/linkAddress/' + this.m_Recipient.ID + '/' + obj.data.ID,
														method: "POST",
														data:
														{
															KindOf: $('#44dd4bc3-96f1-4279-968e-51b0fb453972').val()
														},
														on:
														{
															success: () => this.m_Orga.reload()
														}
													}
												).send();

												app.addNotify(
													{
														body: [ 'Die Adresse wurde erfolgreich angelegt.' ],
														title: [ 'Adrese erfolgreich angelegt' ],
														context: "success",
														timeout: Number(app.getConfigValue("ToastTimeout"))
													}
												);
											}
										}
									},
									Wollmilch.AJAXCallbase_e.APIV1
								).send();
							},
							static: false
						}
					);

					form.rebuild( this );

					form.Initialize();

					this.buildForm( form );

					new ui.base.Button(
						'Speichern',
						{
							context: 'success',
							size: 'xs',
							attr:
							{
								type: 'submit'
							}
						}
					).rebuild( form );

					new ui.base.Button(
						'Zurücksetzen',
						{
							context: 'primary',
							size: 'xs',
							attr:
							{
								type: 'reset'
							}
						}
					).rebuild( form );

					new ui.base.Button(
						'Abbrechen',
						{
							context: 'danger',
							size: 'xs',
							attr:
							{
								type: 'button'
							}
						}
					).rebuild( form ).on( 'click', () => this.remove() );

					return this;
				}

				private buildForm( _form: ui.Form.Form ): void
				{
					SPA.gui.form.SimpleStyledPostalAddress( _form, _form, '' ).forEach(
						( addr ) => _form.Input( addr )
					);

					const fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
						ui.$$.label().text( 'Adresstyp' ).addClass( 'control-label col-xs-12 col-md-2' )
					).appendTo( _form.Root() );

					const _input: ui.Form.BasicInputField = new ui.Form.Select(
						{
							id: '44dd4bc3-96f1-4279-968e-51b0fb453972',
							option: {
								'': 'Bitte auswählen',
								'LIVING_PLACE': 'Wohnhaft',
								'WORKING_PLACE': 'Dienstadresse',
								'OTHER': 'Sonstiges',
								'UNKNOWN': 'Unbekannt'
							},
							required: true
						}
					).rebuild( fg );

					_input.addClass( 'col-sm-12 col-md-5' );

					_form.Input( _input );
				}

			}
		}
	}
}
